<template>
  <div>
    <MovieList :movies="movies" v-if="movies"/>
<!--     <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
    <div slot="no-more"></div>
    <div slot="no-results"></div>
    </infinite-loading>      -->
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
  </div>
</template>

<script>
import MovieList from '@/components/MovieList'
import FixedPopup from '@/components/FixedPopup'
import InfiniteLoading from 'vue-infinite-loading'
import axios from 'axios'
import { SET_TOTAL_RESULTS } from '@/store/mutations.type'
export default {
  name: 'StudioGenre',
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.faculty ? this.faculty.title : '',
      meta: [
        { vmid: 'description', name: 'description', content: this.faculty ? this.faculty.description : '' },
        { vmid: 'keywords', name: 'keywords', content: this.faculty ? this.faculty.keywords : '' }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: window.location.origin + '/' + this.$route.params.slug + '-movies/' }
      ]       
    }
  },
  components: {
    MovieList,
    FixedPopup,
    InfiniteLoading
  },
  data () {
    return {
      page: 1,
      movies: null,
      popupDorms: null,
      errors: [],
      faculty: null
    }
  },
  methods: {
    infiniteHandler ($state) {
      let self = this
      axios.get(`/3/discover/movie?api_key=a11ac97c6bdb99adc0845654be0902a8&with_genres=${this.$route.params.genre}&with_companies=${this.$route.params.genreId}&page=${this.page}`)

        .then(response => {
          // self.pagination = response.data.results
            //if (Array.isArray(self.dorms) && Array.isArray(response.data.results) !== true && Object.keys(response.data.results).length !== 0) {
            if (response.data.results.length !== 0 ) {              
              response.data.results.forEach(item => {
                self.movies.push(item)
              })
              $state.loaded()
            } else {
              $state.complete()
            }          
          // self.dorms = response.data.data.data
          self.popupDorms = response.data.popups
        })
        .catch(e => {
          self.errors.push(e)
        })      
    },    
    getMovies () {
      let self = this
      const params = this.$route.params.genre
      axios.get(`/3/discover/movie?api_key=a11ac97c6bdb99adc0845654be0902a8&with_genres=${this.$route.params.genre}&with_companies=${this.$route.params.genreId}&page=${this.page}`)
     .then(response => {
          self.movies = response.data.results
          self.$store.commit(SET_TOTAL_RESULTS, response.data.total_results)
        //  self.faculty = response.data.faculty
          // console.log(self.faculty)
        //  self.popupDorms = response.data.popups
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  created () {
    this.getMovies()
  },
  watch: {
    $route () {
      this.getMovies()
    }
  }
}
</script>

<style scoped>

</style>
